import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import { FormGroup, FormControl, Validators } from "../Core/reactive-forms.js";
import { showMessage } from "../Core/ui-utils.js";
import { ApiResponse } from "../Core/api-models.js";

document.addEventListener("DOMContentLoaded", () => {
    // Inicializar intl-tel-input para TODOS los campos marcados como 'tel'
    const itiInstances: any = {};
    document.querySelectorAll('.js-iti-phone').forEach((wrapper: any) => {
        const input = wrapper.querySelector('input') as HTMLInputElement;
        if (input) {
            const controlName = input.getAttribute('formControlName');
            if (controlName) {
                itiInstances[controlName] = intlTelInput(input, {
                    initialCountry: "pe",
                    countryOrder: ["pe"],
                    separateDialCode: false,
                    i18n: {
                        searchPlaceholder: "Buscar país"
                    },
                });
            }
        }
    });
    (window as any).itiInstances = itiInstances;

    // 1. Leer Metadata Generada por C# e inicializar FormGroup Automáticamente
    const metadata = (window as any).__FORM_METADATA;

    if (!metadata) {
        console.error("No form metadata found from C#!");
        return;
    }

    const controls: any = {};
    const bindMessages: any = {};

    Object.keys(metadata).forEach(key => {
        const fieldMeta = metadata[key];
        const validatorsArray: any[] = [];
        const messages: any = {};

        fieldMeta.validators.forEach((v: string) => {
            if (v === 'required') {
                validatorsArray.push(Validators.required);
                messages.required = "Este campo es obligatorio.";
            } else if (v === 'requiredTrue') {
                validatorsArray.push(Validators.requiredTrue);
                messages.requiredTrue = "Debe aceptar los términos y condiciones.";
            } else if (v === 'email') {
                validatorsArray.push(Validators.email);
                messages.email = "Por favor, introduce una dirección de correo válida.";
            } else if (v.startsWith('minLength:')) {
                const len = parseInt(v.split(':')[1], 10);
                validatorsArray.push(Validators.minLength(len));
                messages.minlength = `Debe ingresar al menos ${len} caracteres.`;
            } else if (v.startsWith('pattern:')) {
                const pattern = v.substring('pattern:'.length);
                validatorsArray.push(Validators.pattern(new RegExp(pattern)));
                messages.pattern = "Formato inválido.";
            }
        });

        // Validación de Teléfono dinámica para cualquier campo 'tel'
        if (fieldMeta.type === 'tel') {
            validatorsArray.push((val: any) => {
                const iti = (window as any).itiInstances?.[key];
                if (iti && val) {
                    return iti.isValidNumber() ? null : { invalidPhone: true };
                }
                return null;
            });
            messages.invalidPhone = "El número telefónico no es válido.";
        }

        controls[key] = new FormControl(fieldMeta.type === 'checkbox' ? false : '', validatorsArray);
        bindMessages[key] = messages;
    });

    const helpForm = new FormGroup(controls);

    // 2. Elemento del formulario
    const formElement = document.getElementById("helpForm") as HTMLFormElement;

    if (formElement) {
        // 3. Vincular automáticamente todo el formulario al DOM de forma 100% reactiva.
        helpForm.bindToDOM(formElement, bindMessages);

        // 4. Botón de reinicio (Reset/Borrar)
        formElement.addEventListener("reset", () => {
            helpForm.reset();
        });

        // 5. Enviar formulario reactivo validado
        formElement.addEventListener("submit", async (e: Event) => {
            e.preventDefault();

            // Validar teléfonos dinámicamente
            let allPhonesValid = true;
            Object.keys((window as any).itiInstances || {}).forEach(key => {
                const iti = (window as any).itiInstances[key];
                const control = helpForm.get(key);
                if (iti && !iti.isValidNumber()) {
                    control?.setErrors({ invalidPhone: true });
                    control?.markAsTouched();
                    allPhonesValid = false;
                }
            });

            if (!allPhonesValid) return;

            // Validar si el formulario reactivo es válido
            if (helpForm.invalid) {
                Object.keys(helpForm.controls).forEach(key => {
                    helpForm.get(key)?.markAsTouched();
                });
                return;
            }

            const submitBtn = formElement.querySelector('app-button[type="submit"]') as any;
            const originalBtnText = submitBtn?.getAttribute('text') || 'Enviar';

            try {
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.setAttribute('text', 'ENVIANDO...');
                }

                // Obtener valores del formulario
                const payload = { ...helpForm.value };

                // Obtener los números de teléfono internacionales
                Object.keys((window as any).itiInstances || {}).forEach(key => {
                    const iti = (window as any).itiInstances[key];
                    if (iti) {
                        payload[key] = iti.getNumber().replace(/^\+/, "");
                    }
                });

                console.log("¡Datos de ayuda listos!", payload);

                // Enviar al servidor
                const response = await fetch('/Promotion/Help', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                if (response.ok) {
                    const result: ApiResponse = await response.json();
                    if (result.success) {
                        showMessage("¡Éxito!", result.message || "¡Tu consulta ha sido enviada con éxito!", "success");
                        helpForm.reset();
                    }
                } else {
                    const errorData: ApiResponse = await response.json();
                    console.error("Error del servidor:", errorData);
                    throw new Error(errorData.message || "No se pudo enviar tu consulta.");
                }

            } catch (err: any) {
                console.error("Error durante el envío:", err);
                showMessage("Error", err.message || 'Ocurrió un error al procesar tu consulta.', "error");
            } finally {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.setAttribute('text', originalBtnText);
                }
            }
        });
    }

    // Botón Cerrar
    const closeBtn = document.getElementById('closeHelp');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            window.history.back();
        });
    }
});
